export default __webpack_public_path__ + "static/media/artofwar.6d96e101.png";